import config from "google-tag-manager/gtm.config";

const NOOP = () => false;

function pushToDataLayerGTM(...events) {
  const mappedEvents = events.map((e) => ({
    "emun.timestamp": new Date().getTime(),
    "emun.debug": config.isDebug,
    ...e,
  }));
  mappedEvents.forEach((e) => {
    if (e.event in config.modifiers) {
      config.modifiers[e.event](e);
    }
    if (config.isDebug) {
      console.info("gtm", e.event, e);
    }
  });
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(...mappedEvents);
}

export const gtmFactory =
  (options) =>
  (...events) =>
    pushToDataLayerGTM(...events.map((event) => ({ ...options, ...event })));

export default !config.token ? NOOP : pushToDataLayerGTM;
